import { InputField, Preset, presets } from '@/constants/presets';

export interface TextPresetOption {
  value: string;
  label: string;
  description: string;
  fields?: readonly InputField[];
  preset: Preset;
}

// Filter presets to get only text tools (non-absolute URLs with defined fields)
export const textPresetOptions: TextPresetOption[] = presets
  .filter(
    (preset) =>
      !preset.isAbsoluteURL && preset.fields && preset.fields.length > 0,
  )
  .filter(
    (preset) =>
      preset.slug !== 'blog-post' &&
      preset.slug !== 'blog-post-v2' &&
      preset.slug !== 'blog-post-v3',
  )
  .map((preset) => ({
    value: preset.slug,
    label: preset.title,
    description: preset.description,
    fields: preset.fields,
    preset,
  }));

export function createInitialTextPresetFields(
  fields?: readonly InputField[],
): Map<string, any> {
  const newFields = new Map<string, any>();

  fields?.forEach((field) => {
    if (field.initialValue !== undefined) {
      newFields.set(field.name, field.initialValue);
    } else if (field.type === 'radio' && field.radioOptions) {
      const checkedOption = field.radioOptions.find((opt) => opt.checked);
      newFields.set(
        field.name,
        checkedOption?.name || field.radioOptions[0].name,
      );
    } else {
      newFields.set(field.name, '');
    }
  });

  return newFields;
}
